import SignUp from 'pages/SignUp/container';

export default SignUp;
